import React from 'react';
import Image from 'next/image';
import { useCreateAccountProvider } from '@/lib/context';
import { WORK_WITH_FACTORIES_DESCRIPTION } from '@/shared/constants/sourcing-marketplace';
import { SourcingMarketplaceBannerValueProp } from '@/shared/types/sourcing-marketplace';
import './index.less';

interface IProps {
  card: SourcingMarketplaceBannerValueProp;
  signupRedirect: string;
  utmMedium: string;
}

const ExplorePietraServiceCard = ({ card, signupRedirect, utmMedium }: IProps) => {
  const { showSignupDialogFromSourcing } = useCreateAccountProvider();

  return (
    <div className="explore-pietra-service-card">
      <div className={`header ${card.classname}`}>
        <Image
          className="logos"
          width={145}
          height={26}
          src="/images/sourcing/banner/pietra-shopify-logos.svg"
          alt="Build a Shopify brand"
        />
        <h2 className="title">The preferred platform to build a Shopify brand</h2>
        <span
          className="sign-up-button"
          onClick={() => showSignupDialogFromSourcing(WORK_WITH_FACTORIES_DESCRIPTION, signupRedirect, utmMedium)}
        >
          Sign up for Pietra
        </span>
      </div>
      <div className="card">
        <div className={`inner ${card.classname}`}>
          <div className="title">
            <Image width={24} height={24} src={card.icon} alt={card.title} />
            <h3>{card.title}</h3>
          </div>
          <span className="description">{card.description}</span>
        </div>
      </div>
    </div>
  );
};

export default ExplorePietraServiceCard;
